import { DiscountFragment, FormFinancialLineItem, PaymentMethod, ProviderSelection } from '@fox/finance';
import { ConditionalBlockMeta } from '../form-block/conditionals/contracts';
import { FinancialInvoiceMetadata } from '../ticket-block/contracts';

export type TaxRatesData = {
	rates: { id: number; rate: number; default: boolean }[];
	label?: string;
};
export type PaymentBlockMetadataType = {
	provides?: string[];
	requires?: string[];
	provider?: Pick<ProviderSelection, 'method' | 'providerExtension' | 'provider'>[];

	userDetailIds?: { firstName?: string; lastName?: string; email?: string };
	invoice?: PaymentBlockInvoiceMeta;
	fees?: PaymentBlockFee[];
	enableDiscounts?: boolean;
	/** This is almost irrelevant now and conflicting with alwaysCaptureMethod */
	allowZeroPayment?: boolean;
	/**
	 * Always ask for payment details even if no lineitems or $0 amount.
	 * Default behaviour of false will hide payment input in these cases.
	 */
	alwaysCaptureMethod?: boolean;
} & ConditionalBlockMeta;
export type PaymentBlockInvoiceMeta = {
	integrationTypes?: string[];
	reference?: string;
	enabled?: boolean;
	dueDate?: number;
	allowReferenceOverride?: OverrideOption;
	referenceLabelOverride?: string;
};

export enum OverrideOption {
	Disabled = 'Disabled',
	Optional = 'Optional',
	Required = 'Required'
}

export type PaymentBlockFee = {
	id: string;
	type: FeeType;
	amount?: number;
	labelOverride?: string;
	invoice?: FinancialInvoiceMetadata;
	appliesTo?: Pick<ProviderSelection, 'method' | 'providerExtension' | 'provider'>[];
};

export enum FeeType {
	FixedRate = 'Fixed rate',
	Percentage = 'Percentage'
}

export type PaymentBlockRuntimeProps = {
	columnIndex?: number;
	dragId?: string;
	id: string;
	isDragging?: boolean;
	type: string;
	props: { name: string; title: string; type: string };
	token?: string;
	financialConfig?: string;
};

export type ReceiptItem = {
	id: number;
	description: string;
	transactionRef: string;
	receiptNo: string;
	method: string;
	provider: string;
	status: string;
	success: boolean;
	pending: boolean;
	refunded: boolean;
	currency: string;
	ownerType: string;
	ownerId: string;
	who: string;
	lineItems: {
		id: number;
		amount: number;
		comment?: string;
		subscriptionId?: number;
		lineType: {
			name: string;
		};
	}[];
};

export type PaymentAnswerData = {
	method?: PaymentMethod;
	lineItems?: FormFinancialLineItem[];
	discounts?: ValidateDiscountResponse[];
};

export type ValidateDiscountResponse = Pick<DiscountFragment, 'amount' | 'appliesTo' | 'description' | 'discountType' | 'ownerId' | 'ownerType'> & {
	code: string;
	codeId: number;
	discountId: number;
};

export const STATEMENT_PROVIDER = {
	method: PaymentMethod.Statement,
	provider: PaymentMethod.Statement,
	providerExtension: PaymentMethod.Statement,
	name: PaymentMethod.Statement,
	capabilities: []
};

export type PaymentAnswer = {
	intent?: any;
	success?: boolean;
	method?: string;
	methodId?: string;
	invoiceReference?: string;
	successfulPaymentToken?: string;
};
